import React, { useEffect } from 'react';
import QuoteImage from "../assets/images/TransparentUtahTinaQuote.jpg";
import { initMarqueesAndCounters } from "../assets/js/homePage.js";

const ImageWithQuoteSection = () => {
  useEffect(() => {
    initMarqueesAndCounters();
  }, []);

  return (
    <>
      <section className="py-6" style={{ backgroundColor: "#f8f9fa", paddingTop: "5rem", paddingBottom: "5rem" }}>
        <div className="container">
          <div className="row align-items-center quote-row">
            <div className="col-lg-6">
              <img
                src={QuoteImage}
                alt="Tina M. Cannon, State Auditor"
                className="img-fluid rounded quote-image"
              />
            </div>
            <div className="col-lg-6">
              {/* Newly added */}
              <div className="text-left mb-1">
                <p className="lead text-muted mb-1">A Message from State Auditor</p>
                <div className="display-5 fw-bold mb-3 image-with-a-quote-header">Tina M. Cannon</div>
              </div>
              {/* End Newly added */}
              <blockquote className="blockquote">
                <p className="mb-4">
                  "Transparency in government isn't just about compliance—it's about
                  building trust with the people we serve. Every dollar spent, every
                  decision made, should be accessible to those who fund it: the
                  taxpayers."
                </p>
                <footer className="blockquote-footer">
                  <cite title="Source Title" className="blockquote-footer-source-title">Tina M. Cannon, State Auditor</cite>
                </footer>
              </blockquote>
              {/* Newly added */}
              <div className="hero-stats mt-4">
                <div className="stat-item">
                  <div className="stat-number">5000000000+</div>
                  <div className="stat-label">Data Points</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">1800+</div>
                  <div className="stat-label">Entities</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">3504000+</div>
                  <div className="stat-label">Citizens</div>
                </div>
              </div>
              { /* End Newly added */}
              <a className="btn btn-primary mt-3" href="https://auditor.utah.gov/audit-reports/recent-audit-reports/" target="_blank" 
                rel="noopener noreferrer">
                See What The State Auditor Found
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* New Marquee Container */}
      <div className="container no-max-width">
        <div className="py-3" style={{ backgroundColor: "#4A5568" }}>
          <div 
            className="display-5 fw-bold mb-3 text-center image-with-a-quote-header" 
            style={{ color: "var(--tu-off-white"}}
          >
            OVERSEEING 1800+ ENTITIES
          </div>

          {/* Marquee Rows */}
          <div className="marquee-row marquee-rtl" id="marquee-1">
            <span></span>
          </div>

          <div className="marquee-row marquee-ltr" id="marquee-2">
            <span></span>
          </div>

          <div className="marquee-row marquee-rtl marquee-fast" id="marquee-3">
            <span></span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImageWithQuoteSection;